// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__34GU-","rootSuccess":"CompleteLink_rootSuccess__38tjQ","rootFailure":"CompleteLink_rootFailure__O0ciD","isDisabled":"CompleteLink_isDisabled__1VLQ2"};